module.exports = __webpack_public_path__ + "static/kohler-f62774046e506c0b2bef92c59d045651.jpeg";